const setFocus = (element) => {
  setTimeout(() => {
    element && element.focus && element.focus();
  }, 0);
};

export { setFocus as s };
